function normalizaValor(valor) {
  if (valor === null || valor === undefined) {
    return "";
  }

  if (typeof valor === "object") {
    return JSON.stringify(valor);
  }

  return String(valor);
}

export default function serializaCamposAlteradosHistorico(
  original = {},
  atual = {},
  fallback = atual
) {
  const alterados = {};

  Object.keys(atual || {}).forEach((chave) => {
    const valorOriginal = original?.[chave] ?? "";
    const valorAtual = atual?.[chave] ?? "";

    if (normalizaValor(valorOriginal) !== normalizaValor(valorAtual)) {
      alterados[chave] = {
        de: valorOriginal,
        para: valorAtual,
      };
    }
  });

  return JSON.stringify(
    Object.keys(alterados).length > 0 ? alterados : fallback || {}
  );
}
